<h1 mat-dialog-title>Create New Project</h1>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content test-id="create-project-dialog">
  <form class="create-project-form form-full-width">
    <mat-form-field appearance="outline" class="field-space">
      <mat-label>Select a Group</mat-label>
      <mat-select [formControl]="groupPicker">
        <mat-option *ngFor="let group of groupsWithAccess$ | async" [value]="group._id">
          {{ group.label || group._id }}
        </mat-option>
      </mat-select>
      <mat-error>Select a group.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="field-space">
      <mat-label>Name Project</mat-label>
      <input matInput [formControl]="projectsLabel">
      <mat-error *ngIf="projectsLabel.hasError('required')">Project label is required</mat-error>
      <mat-error *ngIf="projectsLabel.hasError('duplicateLabel')">Project label must be unique in the group</mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-dialog-close mat-stroked-button test-id="project-close-button">Close</button>
  <button mat-flat-button  test-id="project-create-button"color="primary" (click)="submit()" [disabled]="!groupPicker.valid || !projectsLabel.valid">
    Create
  </button>
</div>
